import { cn } from '@/theme/utils'

export default function NftDefaultAvatar({
  seed,
  className,
  rounded = true,
  ariaLabel,
}: {
  seed: string
  className?: string
  rounded?: boolean
  ariaLabel?: string
}) {
  const gradients = [
    'from-indigo-500 to-purple-500',
    'from-sky-500 to-cyan-400',
    'from-rose-500 to-pink-500',
    'from-emerald-500 to-teal-400',
    'from-amber-500 to-orange-500',
    'from-fuchsia-500 to-pink-600',
    'from-blue-500 to-violet-500',
    'from-lime-500 to-emerald-500',
  ]

  const index = getDeterministicIndex(seed, gradients.length)
  const gradient = gradients[index]

  return (
    <div
      role='img'
      aria-label={ariaLabel ?? 'NFT default avatar'}
      className={cn(
        'bg-linear-to-br',
        gradient,
        rounded ? 'rounded-md' : undefined,
        'h-full w-full',
        className,
      )}
    />
  )
}

function getDeterministicIndex(value: string, modulo: number): number {
  let hash = 0
  for (let i = 0; i < value.length; i += 1) {
    hash = (hash * 31 + value.charCodeAt(i)) >>> 0
  }
  return modulo > 0 ? hash % modulo : 0
}
